export const phoneNumberRegex = /^(\+?\d+)?\s*(\d{3,})\s*(\d{3,})\s*(\d{1,})$/;
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;